export const VehicleStatuses = {
  Created: 'created' as const,
  Plan: 'plan' as const,
  Payment: 'payment' as const,
  TrackerSetup: 'tracker_setup' as const,
  Active: 'active' as const,
  Archived: 'archived' as const,
}

export const statusLabels: Record<string, string> = {
  created: 'Créé',
  plan: 'Choix du plan',
  payment: 'Paiement',
  tracker_setup: 'Configuration du tracker',
  active: 'Actif',
  archived: 'Archivé',
}

export function getStatusTone(status: string): { bg: string; color: string } {
  switch (status) {
    case 'active':
      return { bg: '#EBFCC0', color: '#8BC135' }
    case 'tracker_setup':
      return { bg: '#FFF0DF', color: '#EDA73D' }
    case 'archived':
      return { bg: '#E6E6E6', color: '#5D739B' }
    default:
      return { bg: '#E9F0FC', color: '#5D739B' }
  }
}
